import { useState } from 'react'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import { meterAccordionOverrides, pulseMeterAccordionOverrides } from './styled-components'

const useMeterInformationAccordion = () => {
  const isPulse = usePulseScope()
  const [expanded, setExpanded] = useState(['basic0'])

  return {
    isPulse,
    expanded,
    onExpandedChange: ({ expanded: newExpanded }) => setExpanded(newExpanded),
    accordionOverrides: isPulse ? pulseMeterAccordionOverrides : meterAccordionOverrides,
  }
}

export default useMeterInformationAccordion
